<template>
    <div>

    </div>
</template>
<script>
export default {

	name: 'index',

	data() {
		return {

		}
	}
}

</script>
<style lang="css" scoped>


</style>
